import React, {Component, Fragment} from 'react'
import {connect} from 'react-redux'
import PageSubTitle from '../PageSubTitle'
import OnboardingPage from './OnboardingPage'
import OnboardingWizard from './OnboardingWizard'
import OnboardingProfileForm from './OnboardingProfileForm'
import { submit } from 'redux-form'
import { update_profile, logged_in_user } from '../../actions/Auth'
import { ensureUsersLoaded, getUser } from '../../actions/Users'
import Loading from '../Loading'

class OnboardingStepUserDetails extends Component {

    componentDidMount() {
        const { dispatch, user_id } = this.props
        dispatch(ensureUsersLoaded([user_id]))
    }

    onNext = () => {
        const { dispatch } = this.props
        return dispatch(submit('onboarding_profile_form'))
    }

    onFormSubmit = ({ first_name, last_name }) => {
        const { dispatch } = this.props
        return dispatch(update_profile({first_name, last_name}))
    }
    
    onFormSubmitSuccess = () => {
        const { history } = this.props
        history.push(`/onboarding/3`)
        return
    }

    render() {
        const { user } = this.props

        return (
            <OnboardingPage>
              <OnboardingWizard current_step={2}
                                prev_step={1}
                                next_step={true}
                                onNextHook={this.onNext}>
                <Fragment>
                  <PageSubTitle>Set your profile</PageSubTitle>
                  <p>This is how you will appear to other users in the system</p>
                  { user &&
                    <OnboardingProfileForm onFormSubmit={this.onFormSubmit}
                                           onFormSubmitSuccess={this.onFormSubmitSuccess}
                                           initialValues={{first_name: user.first_name,
                                                           last_name: user.last_name}}
                    />
                  }
                  { !user && <Loading/> }
                </Fragment>
              </OnboardingWizard>
            </OnboardingPage>
        )
    }
}

function mapStateToProps(state) {

    let user = logged_in_user(state)
    const user_id = user.user_id
    
    if (user_id) {
        user = Object.assign({}, user, getUser(state, user_id))
    }
    
    return {
        user_id,
        user
    }
}

export default connect(mapStateToProps)(OnboardingStepUserDetails)



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingStepUserDetails.js